export default function ResourcesList() {
  return (
    <div className="min-h-screen bg-tg-bg p-4">
      <h1 className="text-2xl font-bold text-tg-text mb-4">Трафик</h1>
      <div className="text-tg-hint">Ресурсы будут здесь...</div>
    </div>
  )
}
